module.exports = new Promise((resolve, reject) => {
        const startTime = Date.now();
        const MAX_RETRIES = 3;
        const RETRY_DELAY = 1500;
        let attempts = 0;
        
        // Determine the remote entry URL
        const ENV_PAYMENT_URLS = {
            production: 'https://assets.nuorder.com/federated/payments/remoteEntry.js',
            staging: 'https://assets.staging.nuorder.com/federated/payments/remoteEntry.js',
            staging02: 'https://assets.stg02.nuorder.com/federated/payments/remoteEntry.js',
            'pre-prd': 'https://assets.pre-prd.nuorder.com/federated/payments/remoteEntry.js',
            sandbox1: 'https://assets.sandbox1.nuorder.com/federated/payments/remoteEntry.js',
            dev:  window.nuConfig.FEDERATED_PAYMENTS_PATH ? window.nuConfig.FEDERATED_PAYMENTS_PATH + '/remoteEntry.js' : 'https://assets.staging.nuorder.com/federated/payments/remoteEntry.js'
        };
        const baseUrl = ENV_PAYMENT_URLS[window.nuConfig?.ENVIRONMENT || 'dev'];
        console.log('[Module Federation] Loading Payments remote from:', baseUrl);
        
        const createProxy = () => ({
            get: (request) => window.Payments.get(request),
            init: (arg) => {
                try {
                    return window.Payments.init(arg);
                } catch(e) {
                    console.error('[Module Federation] Payments container already initialized');
                }
            }
        });
        
        const loadScript = () => {
            const script = document.createElement('script');
            const cacheBuster = attempts > 0 ? '?retry=' + attempts + '&t=' + Date.now() : '';
            const fullUrl = baseUrl + cacheBuster;
            
            console.log('[Module Federation] Attempt', attempts + 1, 'of', MAX_RETRIES, '| URL:', fullUrl);
            
            script.onload = () => {
                const loadTime = Date.now() - startTime;
                console.log('[Module Federation] Successfully loaded Payments remote in', loadTime, 'ms');
                const proxy = createProxy();
                resolve(proxy);
            };
            
            script.onerror = (error) => {
                if (script.parentNode) {
                    script.parentNode.removeChild(script);
                }
                script.onload = null;
                script.onerror = null;
                attempts++;
                const errorDetails = {
                    attempt: attempts,
                    maxRetries: MAX_RETRIES,
                    url: fullUrl,
                    environment: window.nuConfig?.ENVIRONMENT,
                    userAgent: navigator.userAgent,
                    timestamp: new Date().toISOString(),
                    stack: error
                };
                
                if (attempts >= MAX_RETRIES) {
                    console.error('[Module Federation] Failed to load Payments remote after all', MAX_RETRIES, 'attempts');
                    console.error('[Module Federation] Error details:', JSON.stringify(errorDetails, null, 2));
                    reject(new Error('Failed to load Payments remote module after ' + MAX_RETRIES + ' attempts'));
                } else {
                    console.warn('[Module Federation] Retry', attempts, 'of', MAX_RETRIES, 'in', RETRY_DELAY * attempts, 'ms');
                    setTimeout(() => {
                        console.log('[Module Federation] Retrying...');
                        loadScript();
                    }, RETRY_DELAY * attempts);
                }
            };
            
            script.src = fullUrl;
            document.head.appendChild(script);
        };
        
        loadScript();
    });